import React, { createContext, useContext, useState } from 'react'

const GlobalContext = createContext()

export const useGlobalState = () => {
  const context = useContext(GlobalContext)
  if (!context) {
    throw new Error('useGlobalState should be in a GlobalProvider')
  }
  return context
}

export const GlobalProvider = ({ children }) => {
    const [botConfig, setBotConfig] = useState(null)
    const [chatbotList, setChatbotList] = useState([])

    return (
    <GlobalContext.Provider
        value={{
        botConfig,
        setBotConfig,
        chatbotList,
        setChatbotList
        }}
>
      {children}
    </GlobalContext.Provider>
  )
}